//dont remove this comment
// if (ENVIRONMENT !== "dev") {
//   Sentry.init({
//     dsn: "https://f914850df9dd421bbf65e84287044b6e@o1347523.ingest.sentry.io/6626262",
//     integrations: [new BrowserTracing()],
//     tracesSampleRate: 1.0,
//   });
// }
//end part

import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  // <React.StrictMode>
  <Suspense
    fallback={
      <div className="loader_spinner">
        <div className="loader_spinner__box">
          <div className="spin"></div>
        </div>
      </div>
    }
  >
    <BrowserRouter
      future={{
        v7_startTransition: true,
      }}
    >
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </Suspense>,
  // </React.StrictMode>,
);

reportWebVitals();
